import React from 'react';
import PropTypes from 'prop-types';
import { generateMetricsAttribute } from '@sm/metrics';
import { useTheme, createUseStyles } from 'react-jss';
import { Container, Typography, Button } from '@sm/wds-react';
import { Button as WrenchButton } from '@wds/button';
import { createURL } from '@sm/utils';

import './fortune-callout.scss';

const useStyles = createUseStyles(theme => {
  return {
    smWebRespWebButton: {
      backgroundColor: theme.brandColors.neutral.white,
      color: theme.brandColors.primary.sabaeus,
      marginTop: theme.spacing[5],
      paddingLeft: theme.spacing[5],
      paddingRight: theme.spacing[5],
      '&:hover, &:focus': {
        backgroundColor: theme.endpageColors.onHover.transparentWhite,
      },
    },
  };
});

const FortuneCallout = ({ color, copy, ctaText, utSource, utSource2, hideCTAs, route }) => {
  const theme = useTheme();
  const classes = useStyles({ theme });

  return (
    <Container
      data-testid="FortuneCallout"
      flex
      flexJustify="center"
      flexDirection="column"
      className={`sm-fortune-callout sm-fortune-callout--${color} wds-p-7`}
    >
      <Choose>
        <When condition={color === 'sabaeus'}>
          <Typography
            component="h3"
            align="center"
            variant="sectionTitle"
            color="light"
            className="sm-fortune-callout__copy"
          >
            <strong>{copy}</strong>
          </Typography>
        </When>
        <Otherwise>
          <Typography
            component="h3"
            align="center"
            variant="sectionTitle"
            color="primary"
            className="sm-fortune-callout__copy"
          >
            <strong>{copy}</strong>
          </Typography>
        </Otherwise>
      </Choose>
      <Choose>
        <When condition={hideCTAs} />
        <When condition={color === 'sabaeus'}>
          <Button
            size="lg"
            className={classes.smWebRespWebButton}
            href={createURL(route, {
              ut_source: utSource,
              ut_source2: utSource2,
            })}
            data-sm-metric={generateMetricsAttribute({
              data: {
                actionType: `${utSource}_click_fortune_cta_to_sign_up`,
                actionFlow: { utSource },
              },
            })}
          >
            {ctaText}
          </Button>
        </When>
        <Otherwise>
          <WrenchButton
            size="lg"
            color="primary"
            pl={5}
            pr={5}
            mt={6}
            href={createURL(route, {
              ut_source: utSource,
              ut_source2: utSource2,
            })}
            data-sm-metric={generateMetricsAttribute({
              data: {
                actionType: `${utSource}_click_fortune_cta_to_sign_up`,
                actionFlow: { utSource },
              },
            })}
          >
            {ctaText}
          </WrenchButton>
        </Otherwise>
      </Choose>
    </Container>
  );
};

FortuneCallout.propTypes = {
  color: PropTypes.string,
  copy: PropTypes.string.isRequired,
  ctaText: PropTypes.string.isRequired,
  utSource: PropTypes.string,
  utSource2: PropTypes.string,
  hideCTAs: PropTypes.bool,
  route: PropTypes.string,
};

FortuneCallout.defaultProps = {
  color: 'canvas',
  utSource: '',
  utSource2: '',
  hideCTAs: false,
  route: '/user/sign-up/',
};

export default FortuneCallout;
